'use strict';

import FormController from 'app/controllers/form';

class BrandController extends FormController {
  /* @ngInject */
  constructor(BrandsService, $scope, $mdDialog, $mdToast, $state, $location) {
    let brand = $scope.$parent.$resolve.brand;
    super(brand, 'Marca', BrandsService, null, 'brands');

    Object.assign(this, {
      BrandsService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;
  }
}

export default BrandController;
